var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:cash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.75 12.5H44.25V37.5H6.75V12.5ZM25.5 18.75C27.1576 18.75 28.7473 19.4085 29.9194 20.5806C31.0915 21.7527 31.75 23.3424 31.75 25C31.75 26.6576 31.0915 28.2473 29.9194 29.4194C28.7473 30.5915 27.1576 31.25 25.5 31.25C23.8424 31.25 22.2527 30.5915 21.0806 29.4194C19.9085 28.2473 19.25 26.6576 19.25 25C19.25 23.3424 19.9085 21.7527 21.0806 20.5806C22.2527 19.4085 23.8424 18.75 25.5 18.75ZM15.0833 16.6667C15.0833 17.7717 14.6443 18.8315 13.8629 19.6129C13.0815 20.3943 12.0217 20.8333 10.9167 20.8333V29.1667C12.0217 29.1667 13.0815 29.6057 13.8629 30.3871C14.6443 31.1685 15.0833 32.2283 15.0833 33.3333H35.9167C35.9167 32.2283 36.3557 31.1685 37.1371 30.3871C37.9185 29.6057 38.9783 29.1667 40.0833 29.1667V20.8333C38.9783 20.8333 37.9185 20.3943 37.1371 19.6129C36.3557 18.8315 35.9167 17.7717 35.9167 16.6667H15.0833Z",
    fill: "#152344"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.62590db1f59bef9220cb9d8fb8340313.svg";
export { ForwardRef as ReactComponent };